import * as React from "react"

export default function SelectLoading({ ...props }) {
    return <div className='loadingSelect' {...props?.parent}>
        <span className="select" {...props?.children} />
    </div>
}